/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetProductsParams,
  HTTPValidationError,
  PageProductRead,
  Product,
  ProductCreate,
  ProductRead,
  ProductUpdate,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new product.
 * @summary Create Product
 */
export const createProduct = (
  productCreate: ProductCreate,
  signal?: AbortSignal,
) => {
  return customInstance<Product>({
    url: `/api/product/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: productCreate,
    signal,
  });
};

export const getCreateProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProduct>>,
    TError,
    { data: ProductCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProduct>>,
  TError,
  { data: ProductCreate },
  TContext
> => {
  const mutationKey = ["createProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProduct>>,
    { data: ProductCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createProduct(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProduct>>
>;
export type CreateProductMutationBody = ProductCreate;
export type CreateProductMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Product
 */
export const useCreateProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createProduct>>,
      TError,
      { data: ProductCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createProduct>>,
  TError,
  { data: ProductCreate },
  TContext
> => {
  const mutationOptions = getCreateProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many products.
Results are paginated.

Entity is optional and will return visible products for that entity.
 * @summary Get Products
 */
export const getProducts = (
  params?: GetProductsParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageProductRead>({
    url: `/api/product/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetProductsInfiniteQueryKey = (params?: GetProductsParams) => {
  return ["infinite", "api", "product", ...(params ? [params] : [])] as const;
};

export const getGetProductsQueryKey = (params?: GetProductsParams) => {
  return ["api", "product", ...(params ? [params] : [])] as const;
};

export const getGetProductsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getProducts>>,
    GetProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProducts>>,
        TError,
        TData,
        QueryKey,
        GetProductsParams["page"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProductsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProducts>>,
    QueryKey,
    GetProductsParams["page"]
  > = ({ signal, pageParam }) =>
    getProducts({ ...params, page: pageParam || params?.["page"] }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProducts>>,
    TError,
    TData,
    QueryKey,
    GetProductsParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProducts>>
>;
export type GetProductsInfiniteQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetProductsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getProducts>>,
    GetProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetProductsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProducts>>,
        TError,
        TData,
        QueryKey,
        GetProductsParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getProducts>>,
    GetProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProducts>>,
        TError,
        TData,
        QueryKey,
        GetProductsParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getProducts>>,
    GetProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProducts>>,
        TError,
        TData,
        QueryKey,
        GetProductsParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Products
 */

export function useGetProductsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getProducts>>,
    GetProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProducts>>,
        TError,
        TData,
        QueryKey,
        GetProductsParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProductsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProducts>>> = ({
    signal,
  }) => getProducts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProducts>>
>;
export type GetProductsQueryError = ErrorType<void | HTTPValidationError>;

export function useGetProducts<
  TData = Awaited<ReturnType<typeof getProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProducts<
  TData = Awaited<ReturnType<typeof getProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProducts<
  TData = Awaited<ReturnType<typeof getProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Products
 */

export function useGetProducts<
  TData = Awaited<ReturnType<typeof getProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProductsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update a product by ID.
 * @summary Update Product
 */
export const updateProduct = (productUpdate: ProductUpdate) => {
  return customInstance<Product>({
    url: `/api/product/`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: productUpdate,
  });
};

export const getUpdateProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProduct>>,
    TError,
    { data: ProductUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProduct>>,
  TError,
  { data: ProductUpdate },
  TContext
> => {
  const mutationKey = ["updateProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProduct>>,
    { data: ProductUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updateProduct(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProduct>>
>;
export type UpdateProductMutationBody = ProductUpdate;
export type UpdateProductMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Product
 */
export const useUpdateProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProduct>>,
      TError,
      { data: ProductUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProduct>>,
  TError,
  { data: ProductUpdate },
  TContext
> => {
  const mutationOptions = getUpdateProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get an product by ID.
 * @summary Get Product
 */
export const getProduct = (productId: number, signal?: AbortSignal) => {
  return customInstance<ProductRead>({
    url: `/api/product/${productId}`,
    method: "GET",
    signal,
  });
};

export const getGetProductQueryKey = (productId?: number) => {
  return ["api", "product", productId] as const;
};

export const getGetProductQueryOptions = <
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductQueryKey(productId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({
    signal,
  }) => getProduct(productId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!productId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProduct>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProduct>>
>;
export type GetProductQueryError = ErrorType<void | HTTPValidationError>;

export function useGetProduct<
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProduct<
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProduct<
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Product
 */

export function useGetProduct<
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProductQueryOptions(productId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to delete an product by ID.
 * @summary Delete Product
 */
export const deleteProduct = (productId: number) => {
  return customInstance<unknown>({
    url: `/api/product/${productId}`,
    method: "DELETE",
  });
};

export const getDeleteProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProduct>>,
    TError,
    { productId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProduct>>,
  TError,
  { productId: number },
  TContext
> => {
  const mutationKey = ["deleteProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProduct>>,
    { productId: number }
  > = (props) => {
    const { productId } = props ?? {};

    return deleteProduct(productId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProduct>>
>;

export type DeleteProductMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Product
 */
export const useDeleteProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProduct>>,
      TError,
      { productId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProduct>>,
  TError,
  { productId: number },
  TContext
> => {
  const mutationOptions = getDeleteProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Restore an archived (soft-deleted) product.
 * @summary Restore Product
 */
export const restoreProduct = (productId: number, signal?: AbortSignal) => {
  return customInstance<unknown>({
    url: `/api/product/restore/${productId}`,
    method: "POST",
    signal,
  });
};

export const getRestoreProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreProduct>>,
    TError,
    { productId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreProduct>>,
  TError,
  { productId: number },
  TContext
> => {
  const mutationKey = ["restoreProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreProduct>>,
    { productId: number }
  > = (props) => {
    const { productId } = props ?? {};

    return restoreProduct(productId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreProduct>>
>;

export type RestoreProductMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Restore Product
 */
export const useRestoreProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreProduct>>,
      TError,
      { productId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof restoreProduct>>,
  TError,
  { productId: number },
  TContext
> => {
  const mutationOptions = getRestoreProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to check if a product is being used in an order.
 * @summary Check Product Usage
 */
export const checkProductUsage = (productId: number, signal?: AbortSignal) => {
  return customInstance<boolean>({
    url: `/api/product/check/${productId}`,
    method: "GET",
    signal,
  });
};

export const getCheckProductUsageQueryKey = (productId?: number) => {
  return ["api", "product", "check", productId] as const;
};

export const getCheckProductUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof checkProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkProductUsage>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCheckProductUsageQueryKey(productId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkProductUsage>>
  > = ({ signal }) => checkProductUsage(productId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!productId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof checkProductUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CheckProductUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkProductUsage>>
>;
export type CheckProductUsageQueryError = ErrorType<void | HTTPValidationError>;

export function useCheckProductUsage<
  TData = Awaited<ReturnType<typeof checkProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkProductUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkProductUsage>>,
          TError,
          Awaited<ReturnType<typeof checkProductUsage>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckProductUsage<
  TData = Awaited<ReturnType<typeof checkProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkProductUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkProductUsage>>,
          TError,
          Awaited<ReturnType<typeof checkProductUsage>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckProductUsage<
  TData = Awaited<ReturnType<typeof checkProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkProductUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Check Product Usage
 */

export function useCheckProductUsage<
  TData = Awaited<ReturnType<typeof checkProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkProductUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCheckProductUsageQueryOptions(productId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Check if a product exists for a given entity and catalog product combination.
 * @summary Get Product By Combination
 */
export const getProductByCombination = (
  entityId: number,
  catalogProductId: number,
  signal?: AbortSignal,
) => {
  return customInstance<Product>({
    url: `/api/product/lookup/${entityId}/${catalogProductId}`,
    method: "GET",
    signal,
  });
};

export const getGetProductByCombinationQueryKey = (
  entityId?: number,
  catalogProductId?: number,
) => {
  return ["api", "product", "lookup", entityId, catalogProductId] as const;
};

export const getGetProductByCombinationQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductByCombination>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductByCombination>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetProductByCombinationQueryKey(entityId, catalogProductId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProductByCombination>>
  > = ({ signal }) =>
    getProductByCombination(entityId, catalogProductId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(entityId && catalogProductId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductByCombination>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductByCombinationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductByCombination>>
>;
export type GetProductByCombinationQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetProductByCombination<
  TData = Awaited<ReturnType<typeof getProductByCombination>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  catalogProductId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductByCombination>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByCombination>>,
          TError,
          Awaited<ReturnType<typeof getProductByCombination>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductByCombination<
  TData = Awaited<ReturnType<typeof getProductByCombination>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductByCombination>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByCombination>>,
          TError,
          Awaited<ReturnType<typeof getProductByCombination>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductByCombination<
  TData = Awaited<ReturnType<typeof getProductByCombination>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductByCombination>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Product By Combination
 */

export function useGetProductByCombination<
  TData = Awaited<ReturnType<typeof getProductByCombination>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductByCombination>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProductByCombinationQueryOptions(
    entityId,
    catalogProductId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
